export const kitDeviceIdsFromList = (devices) =>
  (devices ?? []).map((d) => Number(d.id));

/** Dispositivo assegnabile a un kit: stessa org, senza kit e senza paziente. */
export const isDeviceEligibleForKit = (device, orgId) => {
  if (orgId == null || orgId === "") return false;
  if (device.kit_id != null && device.kit_id !== "") return false;
  if (device.patient_id != null && device.patient_id !== "") return false;
  if (device.org_id == null || device.org_id === "") return false;
  return Number(device.org_id) === Number(orgId);
};
